export default "__VITE_ASSET__q0r2DLlu__"